<template>
  <v-dialog
    v-model="showDialog"
    @click:outside="closeDialog"
    content-class="service-dialog"
    scrollable
    max-width="900px"
    style="z-index: 9999"
  >
    <v-card class="modal-pay-report custom-tooltips">
      <v-card-title>
        <span class="headline" style="font-size: 1.3rem !important"
          >&nbsp;</span
        >
        <v-btn @click="closeDialog" icon absolute right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text ref="modalContent" class="no-top-bottom-padding">
        <v-container class="no-top-bottom-padding mob-flex-center-height-100">
          <v-row>
            <v-col
              cols="12"
              class="text-center no-bottom-padding display-0-24-no-line-h"
            >
              <span
                v-html="message"
                style="display:block;font-size:16px;margin-bottom:33px"
              >
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row class="d-flex justify-center">
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            class="text-center padding-bottom-52"
          >
            <v-btn
              v-if="!isLogged"
              @click="authDialog"
              large
              color="success"
              class="padding-0-20 hd-gradient"
              >Регистрация</v-btn
            >
            <v-btn
              v-else
              @click="closeDialog"
              color="primary accent-4"
              class="small-med mx-2 hd-gradient"
              >Понятно</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ServiceDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // show: false
    };
  },
  computed: {
    isLogged: {
      get() {
        return this.$store.state.account.User.isLogged;
      },
      set(bulean) {
        this.$store.commit("account/login_success", bulean);
      }
    },
    message() {
      return this.$store.state.conf.serviceDialog.message;
    }
  },
  methods: {
    closeDialog() {
      this.$refs.modalContent.scrollTop = 0;
      this.$emit("close");
    },
    authDialog() {
      this.$emit("loginDialog", true);
    }
  }
};
</script>
